import React from 'react';
import { motion } from 'framer-motion';
const vcs = [{
  name: 'Alchemist',
  url: 'https://alchemistaccelerator.com',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8fPuayV2SnUujQvMRpPnou/alchemist-logo.png'
}, {
  name: 'Race Capital',
  url: 'https://race.capital',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ob8rkz8khc4heP4HErKArY/race-capital.png'
}, {
  name: 'Antler',
  url: 'https://antler.co',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hgirye7hUPRf4DHjevxXfG/antler.png'
}, {
  name: 'Sunset Ventures',
  url: 'https://www.linkedin.com/company/sunsetventures/posts/?feedView=all',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tZ437HpSBjYgAPKabeXyzN/sunset_ventures_light_%281%29.png'
}, {
  name: 'GoAhead Ventures',
  url: 'https://www.goaheadvc.com/',
  logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/osi9n4WoHZgnGToFK1vbxz/goahead-ventures.png'
}];
export function BackedBy() {
  return <section className="py-20 bg-gradient-to-b from-white to-slate-50 border-t border-slate-100 relative overflow-hidden" data-id="element-2">
      {/* Gradient accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-primary" data-id="element-3"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4">
        <div className="text-center mb-12" data-id="element-5">
          <p className="text-sm font-semibold text-gradient-primary uppercase tracking-wider mb-3" data-id="element-6">
            Backed by leading investors
          </p>
          <h2 className="text-3xl font-bold text-slate-900" data-id="element-7">
            Backed by some of the best early-stage VCs
          </h2>
        </div>

        {/* Infinite scrolling VC logos */}
        <div className="relative overflow-hidden" data-id="element-8">
          <motion.div className="flex gap-16 items-center justify-center py-8" animate={{
          x: [0, -1200]
        }} transition={{
          duration: 25,
          repeat: Infinity,
          ease: 'linear',
          repeatType: 'loop'
        }} data-id="element-9">
            {/* Duplicate the array for seamless loop */}
            {[...vcs, ...vcs, ...vcs].map((vc, index) => <a key={index} href={vc.url} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300 group" data-id="element-10">
                <div className="flex items-center justify-center px-8 py-6 bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-primary-cyan/30 transition-all group-hover:scale-105 h-24" data-id="element-11">
                  <img src={vc.logo} alt={vc.name} className="h-10 w-auto object-contain" data-id="element-12" />
                </div>
              </a>)}
          </motion.div>
        </div>
      </div>
    </section>;
}